import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { login } from '../api';

const KPKLogo = () => (
  <svg width="52" height="52" viewBox="0 0 36 36" fill="none">
    <rect width="36" height="36" rx="10" fill="#00a7dc"/>
    <circle cx="14" cy="15" r="5" stroke="#fff" strokeWidth="2.2" fill="none"/>
    <circle cx="14" cy="15" r="2" fill="#fff"/>
    <rect x="18.5" y="14" width="9" height="2.2" rx="1.1" fill="#fff"/>
    <rect x="24.5" y="16.2" width="2.2" height="3.2" rx="1.1" fill="#fff"/>
    <rect x="20.5" y="16.2" width="2.2" height="2.2" rx="1.1" fill="#fff"/>
  </svg>
);

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [botName, setBotName]   = useState('');
  const [telegramRequired, setTelegramRequired] = useState(false);
  const [pendingLogin, setPendingLogin] = useState(null);

  const saveAuth = (data) => {
    localStorage.setItem('auth_token', data.access_token);
    localStorage.setItem('auth_user', JSON.stringify({
      username: data.username,
      full_name: data.full_name,
      role: data.role,
      telegram_id: data.telegram_id,
      telegram_username: data.telegram_username,
    }));
  };

  useEffect(() => {
    fetch('/auth/config')
      .then(r => r.json())
      .then(data => {
        setBotName(data?.telegram_bot_name || '');
        setTelegramRequired(!!data?.telegram_login_required);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!botName) return;
    window.onDashboardTelegramAuth = async (tgUser) => {
      setLoading(true);
      setError('');
      try {
        const { data } = pendingLogin?.login_token
          ? await axios.post('/auth/login/telegram-confirm', {
              login_token: pendingLogin.login_token,
              telegram: tgUser,
            })
          : await axios.post('/auth/telegram', tgUser);
        saveAuth(data);
        if (onLogin) onLogin();
        else window.location.replace(data.role === 'buyer' ? '/findirector' : data.role === 'franchise_menu' ? '/fdm' : '/');
      } catch (err) {
        const detail = err.response?.data?.detail;
        setError(
          detail === 'pending'
            ? 'Telegram найден, но доступ ещё не одобрен в партнёрском портале'
            : detail === 'telegram_not_linked'
              ? 'Telegram ещё не привязан к этому аккаунту. Сначала привяжите его во вкладке Telegram партнёрского портала или обратитесь к администратору.'
              : detail || 'Не удалось войти через Telegram'
        );
      } finally {
        setLoading(false);
      }
    };

    const container = document.getElementById('telegram-login-widget');
    if (!container) return;
    container.innerHTML = '';
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botName);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-request-access', 'write');
    script.setAttribute('data-onauth', 'onDashboardTelegramAuth(user)');
    container.appendChild(script);
    return () => { delete window.onDashboardTelegramAuth; };
  }, [botName, onLogin, pendingLogin]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) { setError('Введите логин и пароль'); return; }
    setLoading(true); setError('');
    try {
      const data = await login(username.trim(), password);
      if (data.telegram_required) {
        setPendingLogin(data);
        setError('');
        setLoading(false);
        return;
      }
      saveAuth(data);
      if (onLogin) onLogin();
      else window.location.replace(data.role === 'buyer' ? '/findirector' : data.role === 'franchise_menu' ? '/fdm' : '/');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(
        detail === 'telegram_not_linked'
          ? 'Telegram ещё не привязан к этому аккаунту. Сначала привяжите его во вкладке Telegram партнёрского портала или обратитесь к администратору.'
          : detail || 'Неверный логин или пароль'
      );
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--brand-dark)', padding: 16,
    }}>
      <div style={{
        width: '100%', maxWidth: 380, padding: '40px 36px',
        background: 'var(--bg2)', borderRadius: 18,
        border: 'none',
        boxShadow: '0 24px 70px rgba(0,0,0,0.35)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}><KPKLogo /></div>
          <div style={{ fontSize: 20, fontWeight: 800, color: 'var(--text1)' }}>Ключ под ключ</div>
          <div style={{ fontSize: 12, color: '#00a7dc', marginTop: 4, fontWeight: 600 }}>
            Аналитика бизнеса
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, color: 'var(--text2, var(--text2))',
              marginBottom: 6, fontWeight: 600 }}>
              Логин
            </label>
            <input
              type="text" value={username} onChange={e => setUsername(e.target.value)}
              autoComplete="username" autoFocus
              style={{
                width: '100%', padding: '11px 14px', background: 'var(--bg3)',
                border: '1px solid var(--border, var(--bg3))', borderRadius: 8,
                color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box',
              }}
              onFocus={e => e.target.style.borderColor = '#00a7dc'}
              onBlur={e  => e.target.style.borderColor = 'var(--border, var(--bg3))'}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 12, color: 'var(--text2, var(--text2))',
              marginBottom: 6, fontWeight: 600 }}>
              Пароль
            </label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              style={{
                width: '100%', padding: '11px 14px', background: 'var(--bg3)',
                border: '1px solid var(--border, var(--bg3))', borderRadius: 8,
                color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box',
              }}
              onFocus={e => e.target.style.borderColor = '#00a7dc'}
              onBlur={e  => e.target.style.borderColor = 'var(--border, var(--bg3))'}
            />
          </div>

          {error && (
            <div style={{
              padding: '10px 14px', borderRadius: 8, marginBottom: 16,
              background: 'rgba(224,72,72,0.15)', border: '1px solid rgba(224,72,72,0.3)',
              color: '#e04848', fontSize: 13,
            }}>{error}</div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '12px',
            background: loading ? 'var(--bg3)' : 'var(--accent)',
            color: loading ? 'var(--text2)' : '#fff',
            border: 'none', borderRadius: 8, cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: 14, fontWeight: 700, letterSpacing: '0.03em',
            boxShadow: loading ? 'none' : 'none',
          }}>
            {loading ? 'Входим…' : 'Войти'}
          </button>
        </form>

        {pendingLogin && (
          <div style={{
            marginTop: 16,
            padding: '12px 14px',
            borderRadius: 10,
            background: 'rgba(14,159,110,0.12)',
            border: '1px solid rgba(14,159,110,0.28)',
            color: '#0e9f6e',
            fontSize: 13,
            lineHeight: 1.45,
          }}>
            Пароль принят. Теперь подтвердите вход через свой Telegram
            {pendingLogin.telegram_username ? ` @${pendingLogin.telegram_username}` : ''}.
          </div>
        )}

        {!pendingLogin && telegramRequired && (
          <div style={{
            marginTop: 16,
            padding: '10px 12px',
            borderRadius: 9,
            background: 'rgba(224,138,0,0.1)',
            border: '1px solid rgba(224,138,0,0.25)',
            color: '#e08a00',
            fontSize: 12,
            lineHeight: 1.45,
          }}>
            Для входа требуется подтверждение через Telegram. После ввода пароля появится второй шаг.
          </div>
        )}

        {botName && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '22px 0 16px' }}>
              <div style={{ height: 1, background: 'var(--border, var(--bg3))', flex: 1 }} />
              <span style={{ color: 'var(--text2, var(--text2))', fontSize: 12 }}>
                {pendingLogin ? 'подтверждение' : 'или'}
              </span>
              <div style={{ height: 1, background: 'var(--border, var(--bg3))', flex: 1 }} />
            </div>
            <div id="telegram-login-widget" style={{ display: 'flex', justifyContent: 'center' }} />
            <div style={{ color: 'var(--text2, var(--text2))', fontSize: 11, textAlign: 'center', marginTop: 10, lineHeight: 1.4 }}>
              Бот: @{botName}. Если кнопка не появилась, откройте бота в Telegram и нажмите Start, затем обновите страницу.
            </div>
          </>
        )}
      </div>
    </div>
  );
}
